




































import Vue from 'vue';
import { Lang } from '@/store/types';

export default Vue.extend({
  computed: {
    myCourses(): Array<Lang> {
      const result = new Array<Lang>();
      if (this.$store.state.user) {
        this.$store.state.user.myCourses.forEach((item: string) => {
          const lang: Lang = this.$store.state.langsL.find((langL: Lang) => langL.id === item);
          result.push(lang);
        });
      }
      return result;
    },
  },
});
